var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 58 636 1139",
    width: 636,
    height: 1139,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#2a89e4}.b{fill:#54a0e9}.c{fill:#45474a}.d{fill:#ff6166}.e{fill:#fc0}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m480.2 1189.1h-326.9c-49.6 0-89.8-40.2-89.8-89.8v-836.8c0-107.4 87.1-194.5 194.5-194.5h117.5c107.5 0 194.6 87.1 194.6 194.5v836.8c0 49.6-40.3 89.8-89.9 89.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b",
    d: "m378.7 1138.7h-123.8c-99.8 0-149.7-16.8-149.7-116.5l36.3-457.2-67.2-283.7c0-104.6 84.8-189.3 189.3-189.3h106.3c104.6 0 189.3 84.7 189.3 189.3l-67.2 283.7 36.4 457.2c0 99.7-50 116.5-149.7 116.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m73 420.5c14-2.3 9.6 24.9 0 31.2-9.5 6.2-66 18.7-66 18.7 0 0 0-38.7 66-49.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m561.8 416.1c-13.8-2.3-9.4 25 0 31.2 9.4 6.2 65.3 18.7 65.3 18.7 0 0 0-38.7-65.3-49.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m81.9 359.5c0 0 38.5 188.1 42.2 224.2 3.7 36.1 7.5 409.8 0 426-7.5 16.2-18.9 12.5-18.9 12.5 0 0-23.3-43.6-23.3-264.1 0-220.5 0-398.6 0-398.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "d",
    d: "m94.2 1088.2c2.5 10 44.8 54.8 47.3 63.6 2.5 8.7-22.4 19.3-47.3-7.5-24.9-26.8 0-56.1 0-56.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "e",
    d: "m149 1138.7c0 0 30.5 8.1 43 31.1 0 0-39.3-1.9-43-31.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m141.5 565c0 0-44-189.3-36.3-224.2 7.7-34.9 104.6-61 211.6-61 106.9 0 203.8 26.1 211.6 61 7.7 34.9-36.4 224.2-36.4 224.2 0 0-59.1-11.2-175.2-11.2-116.1 0-175.3 11.2-175.3 11.2zm175.3 555.6c-130 0-167.8-32.4-167.8-32.4l-26.2 20c77.3 56 194 49.8 194 49.8 0 0 116.6 6.2 193.9-49.8l-26.2-20c0 0-37.8 32.4-167.7 32.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.2d653deafaf7a541a45862910ddb4071.svg";
export { ForwardRef as ReactComponent };